/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBackOrderListViewProps } from './back-order-list';

export default (props: IBackOrderListViewProps) => {
    const { modelTable, pagination } = props;
    return (
        <div className='row'>
            {/* {selection} */}
            {modelTable}
            {pagination}
        </div>
    );
};
